import React from 'react'

import BulkImport from './bulk-import'

const WriteNowImport = () => {
  return (
    <div>
      <BulkImport
        title={
          <span>
            Import WriteNow <b>Group</b> Merge Fields
          </span>
        }
        uploadPath='admin/groups/merge_fields_import'
        templatePath='admin/groups/merge_fields_import/template'
      >
        Import group merge fields, this process will look up the group by ID
        then update the merge fields for that group.
      </BulkImport>
      <BulkImport
        title={
          <span>
            Import WriteNow Group <b>User</b> Merge Fields
          </span>
        }
        uploadPath='admin/group_users/merge_fields_import'
        templatePath='admin/group_users/merge_fields_import/template'
      >
        Import group user merge fields, this process will look up if the user is
        in the group by ID then update the merge fields for that user within
        that group.
      </BulkImport>
    </div>
  )
}

export default WriteNowImport
